import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import Modal from 'modal-react-native-web';
import GoogleMapReact from 'google-map-react';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const turtleIcon = require('../../assets/Turtles/main-turtle.png');
const locationIcon = require('../../assets/icons/pin-active.png');

const styles = StyleSheet.create({
  modalBackgroundView: {
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: '#4F4F4F70',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    width: '75%',
    height: '75%',
    minHeight: 150,
    justifyContent: 'space-around',
    margin: 20,
    backgroundColor: theme.WHITE_COLOR,
    borderRadius: theme.BUTTON_BIG_BORDER_RADIUS,
    padding: theme.CONTAINER_MARGIN * 1.5,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  mapContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
  },
  map: {
    flex: 1,
  },
  turtle: {
    position: 'absolute',
    top: -20,
    left: -10,
    width: 64,
    height: 50,
  },
  messageLocation: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 3,
  },
  messageLocationImage: {
    height: 20,
    width: 20,
  },
  messageLocationText: {
    color: theme.GREEN_DARKER_COLOR,
  },
  modalButton: {
    padding: 10,
    marginTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: theme.BUTTON_BORDER_RADIUS,
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  modalText: {
    fontWeight: 'bold',
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE,
  },
});

export const LocationModal = ({ location }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [latitude, setLatitude] = useState(47.80066);
  const [longitude, setLongitude] = useState(14.222);

  const Marker = () => <Image style={styles.turtle} source={turtleIcon} />;

  async function getLocationFromAddress() {
    try {
      const city = location.split(',')[0];
      const country = location.split(',')[1];
      let newLatitude = 0;
      let newLongitude = 0;

      const response = await fetch(
        `https://cors-anywhere.herokuapp.com/https://geocoder.ls.hereapi.com/6.2/geocode.json?&&city=${city}&country=${country}&gen=9&apiKey=asfsgtwVaioE6nDW7aPw6egFrtsEtOE_osdsSEeh-LU`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            // 'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );
      const body = await response.json();

      switch (response.status) {
        case 200:
          newLatitude = body.Response.View[0].Result[0].Location.DisplayPosition.Latitude;
          newLongitude = body.Response.View[0].Result[0].Location.DisplayPosition.Longitude;
          setLatitude(newLatitude);
          setLongitude(newLongitude);
          break;
        default:
          break;
      }
    } catch (e) {
      // error -> do nothing
    }
  }

  useEffect(() => {
    getLocationFromAddress(location);
  }, [location]);

  return (
    <View>
      <TouchableOpacity
        onPress={() => {
          setModalVisible(true);
        }}
      >
        <View style={styles.messageLocation}>
          <Image style={styles.messageLocationImage} source={locationIcon} />
          <CustomText style={styles.messageLocationText} testID="location">
            {' '}
            {location}{' '}
          </CustomText>
        </View>
      </TouchableOpacity>
      <Modal animationType="fade" transparent visible={modalVisible}>
        <View style={styles.modalBackgroundView}>
          <View style={styles.modalView}>
            <View style={styles.mapContainer}>
              <GoogleMapReact
                testID="Map"
                bootstrapURLKeys={{ key: 'AIzaSyAKzic-jZTFGes1QSryZ93tyr14TVJrk8I' }}
                center={{
                  lat: latitude,
                  lng: longitude,
                }}
                style={{ width: '100%', height: '100%' }}
                defaultZoom={5}
              >
                <Marker testID="myMarker" lat={latitude} lng={longitude} />
              </GoogleMapReact>
            </View>
            <TouchableOpacity
              style={styles.modalButton}
              onPress={() => {
                setModalVisible(false);
              }}
            >
              <CustomText style={styles.modalText} testID="backButton">
                Back
              </CustomText>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </View>
  );
};
